var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 34,
    viewBox: "0 0 5.8208 8.9958",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.225 -149.08)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.23351 0 0 .23351 -198.81 -57.742)",
    fill: "#fff",
    stroke: "#07234a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1055.5 910.5h4v10h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1038.5 889.5h16v31h-16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.796fba5d0d5413b5498b254521c38e1a.svg";
export { ForwardRef as ReactComponent };